import DIApi from './_diApi';

class BankStandardAPI extends DIApi {
  controllerName = 'BankStandards';
}

export default new BankStandardAPI();
